export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SimpleHorizontalIndicator.vue?vue&type=template&id=6a57b810&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-wizard/indicators/SimpleHorizontalIndicator.vue?vue&type=template&id=6a57b810&scoped=true
// module id = bBR3
// module chunks = 41